import { render, staticRenderFns } from "./riskControlTrend.vue?vue&type=template&id=5c90bed0&scoped=true"
import script from "./riskControlTrend.vue?vue&type=script&lang=js"
export * from "./riskControlTrend.vue?vue&type=script&lang=js"
import style0 from "./riskControlTrend.vue?vue&type=style&index=0&id=5c90bed0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c90bed0",
  null
  
)

export default component.exports